/**
 * Настройки сборки в одном месте: остальной код не читает import.meta.env напрямую.
 * Так видно, от чего зависит поведение, и тесты не спотыкаются о переменные окружения.
 */
import { studioAddress } from "./lib/site";

export const config = {
  studioUrl: studioAddress(import.meta.env.VITE_STUDIO_URL),
  /** Общий сайт на точном хосте; герои и собственные домены продолжают читать /hero. */
  baseDomain: (import.meta.env.VITE_BASE_DOMAIN ?? "ai.scrile.com").trim().toLowerCase(),
  /** Явная совместимость со старыми стендами; новый основной домен оставляет пустым. */
  rootHeroSlug: (import.meta.env.VITE_ROOT_HERO_SLUG ?? "").trim(),
  /** Мок-API вместо apps/platform: всё живёт во вкладке браузера. */
  mock: import.meta.env.VITE_MOCK === "1",
  /** Dev-сборка: строгая проверка ответов по контракту и заголовок x-hero. */
  dev: import.meta.env.DEV,
  /** Герой по умолчанию на localhost; на проде героя определяет сервер по Host. */
  devHero: (import.meta.env.VITE_HERO ?? "").trim().toLowerCase(),
} as const;
